import { Sample } from '../../../../@types/samples/types';
import { RegressionTarget } from './types';

interface CurveData {
  swArr: (number | null)[];
  kArr: (number | null)[];
  swi: number;
}

export function extractCurves(
  sample: Sample | null | undefined, 
  target: RegressionTarget
): CurveData {
  
  if (!sample) {
    return { swArr: [], kArr: [], swi: 0 };
  }

  const inputValues = sample.input_sample_values;
  const inputCurves = sample.input_sample_curves;

  let swArr: (number | null)[] = [];
  let kArr: (number | null)[] = [];
  let swi = 0;

  switch (target) {
    case 'water_oil_kro':
      swArr = inputCurves?.water_oil?.sw_krel || [];
      kArr = inputCurves?.water_oil?.kro_lab || [];
      swi = inputValues?.swi ?? 0;
      break;

    case 'gas_oil_kro':
      swArr = inputCurves.gas_oil?.sg_krel || []
      kArr = inputCurves.gas_oil?.kro_lab || [];
      swi = sample.k_rel_values?.gas_oil.sgc ?? 0;
      break;

    case 'water_oil_krw':
      swArr = inputCurves?.water_oil?.sw_krel || [];
      kArr = inputCurves?.water_oil?.krw_lab || [];
      swi = inputValues?.swi ?? 0;
      break;

    case 'gas_oil_krg':
      swArr = inputCurves?.gas_oil?.sg_krel || [];
      kArr = inputCurves?.gas_oil?.krg_lab || [];
      swi = sample.k_rel_values?.gas_oil?.sgc ?? 0; 
      break;

    default:
      break;
  }

  return { swArr, kArr, swi };
}